module.exports = __webpack_public_path__ + "static/media/mga.d077581b.svg";